import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import ProductoForm from "./ProductoForm";


const ProductoNew = () => {
  const navigate = useNavigate()

  const onCreate = async (prod) => {
    prod.activo = true;
    await axios.post(Apis.PROD + '/producto/new',prod)
      .then(res => {
        successToast("Producto creado correctamente")
        navigate('/productos')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Productos' onClick={() => navigate('/productos')}/>
        <PageTitle title={'Producto nuevo'}/>
      </PageSection>

      <PageSection>
        <ProductoForm value={{}} onSubmit={(prod) => onCreate(prod)}/>
      </PageSection>
    </PageContainer>
  )
}

export default ProductoNew;
